import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <div className="flex items-center gap-3" data-testid={`eyebrow-${String(children).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
    <span className="h-px w-8 bg-gold" />
    <span className={`font-mono2 text-[11px] font-semibold uppercase tracking-[0.28em] ${dark ? "text-gold-light" : "text-gold"}`}>
      {children}
    </span>
  </div>
);
